'use strict'
import axios from 'axios'

/* eslint-disable */

// axios example
// https://github.com/axios/axios

// service naming conventions
// https://restfulapi.net/resource-naming/
// -- use hyphens, not underscore, for readability

// axios tutorial
// https://medium.com/codingthesmartway-com-blog/getting-started-with-axios-166cb0035237
// video
// https://www.youtube.com/watch?v=1vbpBDWu1AQ

export default {
    init(classHash, studentHash) {
        // validates student hash, class is valid/active and student is attendee
        // returns
        // -- validation results
        // NA -- after class activity (SVA, survey or none)
        // indicators if student complated: eval, exam
        let data = { s: studentHash, c: classHash }
        return axios.get('/api/init', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    login(username, password) {
        let data = { u: username, p: password }
        return axios.post('/api/login',data).then(res => res.data).catch(e => console.log(e) )
    },
    recover(username, email) {
        let data = { u: username, m: email }
        return axios.post('/api/recover',data).then(res => res.data).catch(e => console.log(e) )
    },
    validateUsername(studentHash,username) {  // returns true if username can be used
        let data = { s: studentHash, u: username }
        return axios.get('/api/validate-username',{params: data}).then(res => res.data.status).catch(e => console.log(e) )
    },
    validateEmail(studentHash,email) {  // returns true if email can be used
        let data = { s: studentHash, email: email }
        return axios.get('/api/validate-email',{params: data}).then(res => res.data.status).catch(e => console.log(e) )
    },
    validateAgdNumber(studentHash,agdNumber) {  // returns true if email can be used
        let data = { s: studentHash, agdNumber: agdNumber }
        return axios.get('/api/validate-agd-number',{params: data}).then(res => res.data.status).catch(e => console.log(e) )
    },
    register(data) {
        return axios.post('/api/register',data).then(res => res.data).catch(e => console.log(e) )
    },
    support(data) {
        return axios.post('/api/support',data).then(res => res.data).catch(e => console.log(e) )
    },
    getStudent(studentHash) {
        let data = { s: studentHash }
        return axios.get('/api/student',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    hideAgdReminder(studentHash) {
        let data = { s: studentHash }
        return axios.get('/api/hide-agd-reminder',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getSearchItems() {
        return axios.get('/api/search-items').then(res => res.data).catch(e => console.log(e) )
    },
    getAccountItems(studentHash) {
        let data = { s: studentHash }
        return axios.get('/api/account-items',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getAccountHome(studentHash) {
        // returns ce status for account home tab
        let data = { s: studentHash }
        return axios.get('/api/account-home',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    sendReport(studentHash) {  // Verification of Participation report
        let data = { s: studentHash }
        return axios.get('/api/send-ce-report',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    sendCert(studentHash, classHash, podcastHash) {  // send cert for class or podcast
        let data = { s: studentHash, c: classHash, p:podcastHash }
        return axios.post('/api/send-cert', data).then(res => res.data).catch(e => console.log(e) )
    },
    getProfile(studentHash) {
        let data = { s: studentHash }
        return axios.get('/api/profile',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    saveProfile(data) {
        // POST saves profile
        return axios.post('/api/profile', data).then(res => res.data).catch(e => console.log(e) )
    },
    removeConsent(hash) {
        // POST saves profile
        let data = {h: hash}
        return axios.post('/api/remove-consent', data).then(res => res.data).catch(e => console.log(e) )
    },
    getBlurb(code) {
        let data = { code: code }
        return axios.get('/api/blurb',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getSearch(studentHash, catId, compId, query) {
        let data = { cid: catId, coid: compId, q: query, s: studentHash }
        return axios.get('/api/search',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getHome(studentHash) {
        let data = { s: studentHash }
        return axios.get('/api/home',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getClass(classHash, studentHash) {
        let data = { c: classHash, s: studentHash }
        return axios.get('/api/class',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    removeQueue(classHash, studentHash) {
        let data = { c: classHash, s: studentHash }
        return axios.get('/api/remove-queue',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getCancelSeat(cancelCode, studentHash) {
        let data = { code: cancelCode, s: studentHash }
        return axios.get('/api/cancel-seat',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    cancelSeat(cancelCode, studentHash) {
        let data = { code: cancelCode, s: studentHash }
        return axios.post('/api/cancel-seat', data).then(res => res.data).catch(e => console.log(e) )
    },
    getPodcast(podcastHash, studentHash) {
        let data = { p: podcastHash, s: studentHash }
        return axios.get('/api/podcast',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getBlogPost(blogId, studentHash, blockLog) {
        let data = { b: blogId, s: studentHash, blockLog: blockLog }
        return axios.get('/api/blog-post',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getPodcastShow(podcastShowHash,studentHash) {
        let data = { ps: podcastShowHash, s: studentHash }
        return axios.get('/api/podcast-show',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getPending(studentHash,page) {
        let data = { s: studentHash, page: page }
        return axios.get('/api/pending', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getSeats(studentHash) {
        let data = { s: studentHash }
        return axios.get('/api/seats', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getQueue(studentHash,page) {
        let data = { s: studentHash, page: page }
        return axios.get('/api/queue', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    saveQueue(classHash, studentHash) {
        let data = { c: classHash, s: studentHash }
        return axios.post('/api/queue-add', data).then(res => res.data).catch(e => console.log(e) )
    },
    getCompleted(studentHash) {
        // gets summary data of webinars and podcasts
        let data = { s: studentHash }
        return axios.get('/api/completed', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getCompletedWebinars(studentHash,page) {
        let data = { s: studentHash, page: page }
        return axios.get('/api/completed-webinars', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getCompletedPodcasts(studentHash,page) {
        let data = { s: studentHash, page: page }
        return axios.get('/api/completed-podcasts', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getTutorialHistory(studentHash,page) {
        let data = { s: studentHash, page: page }
        return axios.get('/api/tutorial-history', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getMobileAd(adId,studentHash) {
        let data = { s: studentHash, a: adId }
        return axios.get('/api/mobilead', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    submitMobileAd(adId,studentHash, email) {
        let data = { s: studentHash, a: adId, e: email }
        return axios.post('/api/mobilead-submit', data).then(res => res.data).catch(e => console.log(e) )
    },
    logFeaturedContentClick(studentHash, slotTypeId, featuredHash) {
        let data = { s: studentHash, t: slotTypeId, h: featuredHash }
        return axios.post('/api/featuredcontent-click', data).then(res => res.data).catch(e => console.log(e) )
    },
    getSva(classHash,studentHash) {
        // console.log(`getSva s: ${studentHash}  c: ${classHash}`)
        let data = { s: studentHash, c: classHash }
        return axios.get('/api/sva', {params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    saveSvaResponse(classHash, studentHash, campaignId, eventId) {
        // eventId: 1=view, 2=YES, 3=NO
        let data = { s: studentHash, c: classHash, v: campaignId, e: eventId }
        return axios.post('/api/save-sva-response',data).then(res => res.data).catch(e => console.log(e) )
    },
    getSurvey(classHash, studentHash) {
        let data = { c: classHash, s: studentHash }
        return axios.get('/api/survey',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    saveSurveyResponse(data) {
        return axios.post('/api/save-survey-response',data).then(res => res.data).catch(e => console.log(e) )
    },
    classStart(classHash, studentHash) {
        // called when student launches live webinar
        // sets attendee.studentStarted
        // on first time creates gradebook with attendeeId
        // every time increments classViewCount
        let data = { c: classHash, s: studentHash }
        return axios.get('/api/class-start',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    classView(classHash, studentHash) {
        // called when student launches opens class view
        let data = { c: classHash, s: studentHash }
        return axios.get('/api/class-view',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    podcastView(podcastHash, studentHash) {
        // called when student launches opens class view
        let data = { p: podcastHash, s: studentHash }
        return axios.get('/api/podcast-view',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    saveAffidavit(data) {
        return axios.post('/api/save-affidavit',data).then(res => res.data).catch(e => console.log(e) )
    },
    saveEval(data) {
        return axios.post('/api/save-eval',data).then(res => res.data).catch(e => console.log(e) )
    },
    getExam(classHash, podcastHash, studentHash) {
        let data = { c: classHash, p: podcastHash, s: studentHash,  }
        return axios.get('/api/exam',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    gradeExam(data) {
        return axios.post('/api/grade-exam',data).then(res => res.data).catch(e => console.log(e) )
    },
    getUpcoming(studentHash, catId, compId, keyword, page) {
        let data = { s: studentHash, cid: catId, coid: compId, q: keyword, page: page }
        // Gets upcoming classes
        return axios.get('/api/upcoming',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getOndemand(studentHash, catId, compId, keyword, page) {
        let data = { s: studentHash, cid: catId, coid: compId, q: keyword, page: page }
        // Gets upcoming classes
        return axios.get('/api/ondemand',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getPodcasts(studentHash, catId, compId, keyword, page) {
        let data = { s: studentHash, cid: catId, coid: compId, q: keyword, page: page }
        // Gets upcoming classes
        return axios.get('/api/podcasts',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getBlogPosts(studentHash, catId, compId, keyword, page) {
        let data = { s: studentHash, cid: catId, coid: compId, q: keyword, page: page }
        // Gets upcoming classes
        return axios.get('/api/blog-posts',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getTutorials(studentHash, catId, compId, keyword, page) {
        let data = { s: studentHash, cid: catId, coid: compId, q: keyword, page: page }
        // Gets upcoming classes
        return axios.get('/api/tutorials',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    getBooks(studentHash) {
        let data = { s: studentHash }
        // Gets upcoming classes
        return axios.get('/api/books',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    saveBookResponse(data) {
        return axios.post('/api/book-response-mvp',data).then(res => res.data).catch(e => console.log(e) )
    },
    reserveSeat(classHash, studentHash) {
        // Reserves seat for class
        let data = { s: studentHash, c: classHash }
        return axios.get('/api/reserve-seat',{params: data}).then(res => res.data).catch(e => console.log(e) )
    }
}


// WEBPACK FOOTER //
// ./src/service/service.js